export enum SessionStorageNames {
    INIT = "fq-response-dati-form-calcola-targa",
    CURRENT_URL = 'fq-current-navigation-url',
    LEAD_ID = 'fq-lead-id'
}